import React from "react";

import ToolbarCommon from "./toolbar.common";
import ToolbarLiveConditions from "src/modules/liveConditions/components/toolbar/toolbar.liveconditions";

export default class ToolbarMobileV2 extends ToolbarCommon {

    public get style(): any {
        const {toolbar} = this.props;
        return {
            '--text-color': toolbar.text_color?.value,
            '--hover-color': toolbar.hover_color?.value,
            '--background': this.props.toolbar?.background_color_when_attached_on_mobile?.value ||
                            this.props.toolbar?.background_color?.value || '#fff',
        }
    }

    get items(){
        return this.props.toolbar.items.filter(item => item.item.mobile_fixed_at_top === false).map((item, index) => this.renderToolbarItem(item, index))
    }

    renderLiveConditions() {
        if (!this.props.toolbar.bars_live_conditions) return null;
        return (
            <ToolbarLiveConditions
                bars_live_conditions={this.props.toolbar.bars_live_conditions}
                language={this.props.language}
                defaultLanguage={this.props.defaultLanguage}
            />
        );
    }

    public render() {
        const hasItems = this.items.length > 0;
        const hasLiveConditions = !!this.props.toolbar.bars_live_conditions;
        
        if (!hasItems && !hasLiveConditions) return null;
        
        return (
            <div className="toolbar mob-toolbar flex flex-col p-4 gap-6 bg-[color:var(--background)]" style={this.style}>
                {this.renderLiveConditions()}
                {this.items}
            </div>
        );
    }
}